import React from 'react';
import { Spin, Empty } from 'antd';
import cn from 'classnames';
import UploadButton from '../UploadButton/UploadButton';
import Card, { CardHeader } from '../Card';
import AttachmentsList from '../AttachmentsList/AttachmentsList';
import useCardPagination from '../../hooks/useCardPagination';
import styles from './CardAttachments.module.scss';

const CardAttachments = ({
  rootClassName,
  title,
  paginationClassName,
  attachments,
  pageSize,
  uploadButtonProps = {},
  showUpload = true,
  cardStyle = {},
  loading = false,
  getAttachmentUrl,
  onDeleteAttachment,
  showMetaData,
}) => {
  const { shownItems, pagination } = useCardPagination(
    attachments || [],
    pageSize,
    paginationClassName
  );

  const uploadButton = showUpload ? (
    <UploadButton {...uploadButtonProps} className={styles.upload} />
  ) : null;

  return (
    <Card className={cn(styles.root, rootClassName)} style={cardStyle}>
      <CardHeader
        title={title}
        action={attachments?.length > pageSize ? pagination : null}
        className={styles.header}
      />
      <Spin wrapperClassName={styles.spin} spinning={loading}>
        {!attachments?.length ? (
          <>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            {uploadButton}
          </>
        ) : (
          <>
            <AttachmentsList
              rootClassName={styles.attachmentsList}
              shownAttachments={shownItems || []}
              allAttachments={attachments}
              getAttachmentUrl={getAttachmentUrl}
              onDeleteAttachment={onDeleteAttachment}
              showMetaData={showMetaData}
            />
            {uploadButton}
          </>
        )}
      </Spin>
    </Card>
  );
};

export default CardAttachments;
